import makeLevel from '../makeLevel.js';
import * as powerups from '../../powerups.js';

export default makeLevel([
  "y*             **y**",
  "*y*           **y** ",
  " *y*         **y**  ",
  "  *y*       **y**   ",
  "   *y*     **y**    ",
  "    *y*   **y**     ",
  "     *y* **y**      ",
  "      *y**y**       ",
  "       *!!!*        ",
  "      **y**         ",
  "     **y**          ",
  "    **y**           ",
  "   **y**            ",
  "  **y**             ",
  " **y**              ",
  " *y**               ",
  " y**                ",
  " **                 ",
  " *                  ",
  "                    "
], [
    {
        "9": powerups.ballSpeedDown,
        "12": powerups.ballExtra,
        "15": powerups.ballSpeedDown,
        "19": powerups.paddleLasers,
        "31": powerups.ballUnstopable,
        "33": powerups.ballSpeedUp,
        "37": powerups.ballSpeedUp,
        "39": powerups.ballUnstopable,
        "52": powerups.paddleShrink,
        "56": powerups.paddleGrow,
        "59": powerups.ballUnstopable,
        "62": powerups.skipLevel,
        "79": powerups.ballExploding,
        "87": powerups.paddleShrink,
        "101": powerups.ballSpeedDown
    },
    {
        "7": powerups.ballExploding,
        "20": powerups.ballExtra,
        "21": powerups.ballExtra,
        "24": powerups.ballSpeedDown,
        "36": powerups.ballSpeedDown,
        "37": powerups.ballSpeedUp,
        "39": powerups.weakenBlocks,
        "46": powerups.instaDeath,
        "49": powerups.paddleShrink,
        "66": powerups.paddleLasers,
        "73": powerups.extraLive,
        "76": powerups.ballSpeedUp,
        "80": powerups.paddleSticky,
        "83": powerups.ballExploding,
        "85": powerups.instaDeath,
        "98": powerups.ballUnstopable
    },
    {
        "14": powerups.instaDeath,
        "15": powerups.paddleLasers,
        "21": powerups.ballExtra,
        "23": powerups.paddleGrow,
        "46": powerups.paddleLasers,
        "50": powerups.paddleShrink,
        "54": powerups.paddleShrink,
        "60": powerups.paddleMini,
        "64": powerups.paddleMini,
        "65": powerups.paddleSticky,
        "67": powerups.ballExtra,
        "68": powerups.ballExploding,
        "70": powerups.ballExtra,
        "80": powerups.ballUnstopable,
        "82": powerups.ballSpeedDown
    },
    {
        "1": powerups.ballSpeedUp,
        "11": powerups.paddleGrow,
        "16": powerups.paddleLasers,
        "19": powerups.ballExtra,
        "28": powerups.paddleShrink,
        "30": powerups.paddleGrow,
        "32": powerups.ballExtra,
        "33": powerups.ballSpeedUp,
        "40": powerups.ballUnstopable,
        "51": powerups.ballExtra,
        "54": powerups.ballUnstopable,
        "55": powerups.instaDeath,
        "59": powerups.paddleSticky,
        "60": powerups.paddleMini,
        "62": powerups.extraLive,
        "74": powerups.paddleMini,
        "84": powerups.paddleGrow,
        "87": powerups.ballExtra,
        "94": powerups.paddleLasers,
        "104": powerups.ballExtra
    }
]);
